var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#7F91A5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 1l6 3-6 3V1zM6 11.083c-2.892.245-5 1.011-5 1.917 0 1.104 3.134 2 7 2s7-.896 7-2c0-.906-2.108-1.671-5-1.917M8.002 12.5V7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlag);
export default __webpack_public_path__ + "static/media/icon-flag.21373da5d81ad9138ee3293f9f37aa0e.svg";
export { ForwardRef as ReactComponent };